import { combineReducers } from 'redux';

import userProfile from './user-profile/reducer';
import menu from './menu/reducer';

export default combineReducers({ userProfile, menu });
